import api from '../../services/api';
import { Profile } from './profileSlice';

export interface ProfileUpdate {
  email?: string;
  name?: string;
  telefono?: string;
  address?: string;
  photo?: File;
}

async function getProfile() {
  const response = await api<Profile>(
    'GET',
    'usuarios'
  );

  return response;
}

async function updateProfile(params: ProfileUpdate) {
  const response = await api<Profile>(
    'POST',
    'usuarios',
    {
      ...params,
      _method: 'PUT',
    }
  );

  return response;
}

const questionsAPI = {
  getProfile,
  updateProfile,
};

export default questionsAPI;
